class InputValidation {
  constructor(container) {
    this.shopLocale = Theme.settings.shop_locale;
    this.storeHandle = Theme.settings.store_handle;
    this.eventToShowDeliveryMethodsWasTriggered = false;
    this.container = container;
  }

  showError(wrapper) {
    if (!wrapper) return;
    wrapper.classList.add('has-error');
  }

  clearError(wrapper) {
    if (!wrapper) return;
    wrapper.classList.remove('has-error');
  }

  isAddressFilled() {
    const addressInput = this.container?.querySelector('input[name="checkout-address"]');
    const cityInput = this.container?.querySelector('input[name="checkout-city"]');
    const postcodeInput = this.container?.querySelector('input[name="checkout-postcode"]');
    if(addressInput?.value && cityInput?.value && postcodeInput?.value) {
      const details = {
        address: addressInput?.value,
        city: cityInput?.value,
        postcode: postcodeInput?.value
      };
      return  this.container.dispatchEvent(new CustomEvent('checkout:address-filled', { detail: details }));
    }
    return;
  }

  addressIsNotFilledCorrectly() {
    return  this.container.dispatchEvent(new Event('checkout:address-not-filled-correctly'));
  }

  validateInput(input) {
    const wrapper = input.closest('[data-input-wrapper]');
    if (!wrapper) return;
    const inputId = input?.id?.trim();
    if (!inputId) return;

    const value = input.value.trim();
    const sanitizedValue = value.replace(/\s/g, '');
    let isError = false;
    if (this.storeHandle === 'wellvita-be') {
      isError = this.validateInputBelgium(inputId, value, sanitizedValue);
    } else {
      // Route to the appropriate validation method based on shop locale
      switch (this.shopLocale) {
        case 'sv':
          isError = this.validateInputSweden(inputId, value, sanitizedValue);
          break;
        case 'da':
          isError = this.validateInputDenmark(inputId, value, sanitizedValue);
          break;
        case 'no':
          isError = this.validateInputNorway(inputId, value, sanitizedValue);
          break;
        case 'fi':
          isError = this.validateInputFinland(inputId, value, sanitizedValue);
          break;
        case 'nl':
          isError = this.validateInputNetherlands(inputId, value, sanitizedValue);
          break;
        default:
          isError = this.validateInputDefault(inputId, value, sanitizedValue);
          break;
      }
    }
    if(inputId === 'checkout-phone') this.removeCountryCodeFromPhoneInput(input);
    if(!isError) if(inputId === 'checkout-address') isError = this.validateAddress(input);

    // Toggle Greenland vs default error message for postcode
    if (inputId === 'checkout-postcode') {
      const greenlandError = wrapper.querySelector('[data-checkout-error-greenland]');
      const defaultError = wrapper.querySelector('[data-checkout-error]');
      if (isError === 'greenland') {
        if (greenlandError) greenlandError.classList.remove('d-none');
        if (defaultError) defaultError.style.display = 'none';
      } else {
        if (greenlandError) greenlandError.classList.add('d-none');
        if (defaultError) defaultError.style.display = '';
      }
    }

    if (isError) {
      this.showError(wrapper);
      if(inputId === 'checkout-address') this.showErrorAutocomplete();
      if(this.eventToShowDeliveryMethodsWasTriggered){
        if(inputId === 'checkout-address' || inputId === 'checkout-city' || inputId === 'checkout-postcode') {
          this.addressIsNotFilledCorrectly();

        }
      }
      return false;
    } else {
      this.clearError(wrapper);
      if(inputId === 'checkout-address') this.clearErrorAutocomplete();
      if(inputId === 'checkout-address' || inputId === 'checkout-city' || inputId === 'checkout-postcode') {
        this.isAddressFilled();
        this.eventToShowDeliveryMethodsWasTriggered = true;
      }

      return true;
    }
  }

  removeCountryCodeFromPhoneInput(input) {
    if (input.value.includes('+45')) input.value = input.value.replace('+45', '');
    if (input.value.includes('+46')) input.value = input.value.replace('+46', '');
    if (input.value.includes('+47')) input.value = input.value.replace('+47', '');
    if (input.value.includes('+31')) input.value = input.value.replace('+31', '');
    if (input.value.includes('+358')) input.value = input.value.replace('+358', '');
    if(input.value.length > 0) {
      return input.value = input.value.replace(/ /g,'');
    }
    return input.value;
  }

  validateAddress(input) {
    const regex = /^(?=.*[A-Za-z])(?=.*\d).+\s.+$/;
    const isValid = regex.test(input.value);
    return !isValid;
  }

  showErrorAutocomplete() {
    const autoCompleteWidget = document.querySelector('gmp-place-autocomplete')
    if(autoCompleteWidget){
      autoCompleteWidget.classList.add('has-error');
    }
  }

  clearErrorAutocomplete() {
    const autoCompleteWidget = document.querySelector('gmp-place-autocomplete')
    if(autoCompleteWidget){
      autoCompleteWidget.classList.remove('has-error');
    }
  }


  validateInputSweden(inputId, value, sanitizedValue) {
    switch (inputId) {
      case 'checkout-email':
        return !/^\S+@\S+\.\S+$/.test(value);
      case 'checkout-phone':
        // Swedish phone numbers (e.g., +46701234567 or 0701234567)
        return !/^(?:\+46|0)?[1-9]\d{7,9}$/.test(sanitizedValue);
      case 'checkout-postcode':
        // Swedish postcodes are 5 digits
        return !/^\d{5}$/.test(sanitizedValue);
      default:
        return value === '';
    }
  }

  validateInputDenmark(inputId, value, sanitizedValue) {
    switch (inputId) {
      case 'checkout-email':
        return !/^\S+@\S+\.\S+$/.test(value);
      case 'checkout-phone':
        // Danish phone numbers are 8 digits
        return !/^(\+45)?\d{8}$/.test(sanitizedValue);
      case 'checkout-postcode':
        // Danish postcodes are 4 digits
        if (!/^\d{4}$/.test(sanitizedValue)) return 'format';
        // Greenland postcodes start with 39 (3900-3985)
        if (sanitizedValue.startsWith('39')) return 'greenland';
        return false;
      default:
        return value === '';
    }
  }

  validateInputNorway(inputId, value, sanitizedValue) {
    switch (inputId) {
      case 'checkout-email':
        return !/^\S+@\S+\.\S+$/.test(value);
      case 'checkout-phone':
        // Norwegian phone numbers are 8 digits
        return !/^(\+47)?\d{8}$/.test(sanitizedValue);
      case 'checkout-postcode':
        // Norwegian postcodes are 4 digits
        return !/^\d{4}$/.test(sanitizedValue);
      default:
        return value === '';
    }
  }

  validateInputDefault(inputId, value, sanitizedValue) {
    switch (inputId) {
      case 'checkout-email':
        return !/^\S+@\S+\.\S+$/.test(value);
      case 'checkout-phone':
        return !/^(\+\d{8,10}|\d{8,10})$/.test(sanitizedValue);
      case 'checkout-postcode':
        return !/^\d{4}$/.test(sanitizedValue);
      default:
        return value === '';
    }
  }

  validateInputFinland(inputId, value, sanitizedValue) {
    switch (inputId) {
      case 'checkout-email':
        return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      case 'checkout-phone':
        // Finnish phone numbers are 8 digits
        return !/^\d{7,12}$/.test(sanitizedValue);
      case 'checkout-postcode':
        // Finnish postcodes are 5 digits
        return !/^\d{5}$/.test(sanitizedValue);
      default:
        return value === '';
    }
  }
  validateInputNetherlands(inputId, value, sanitizedValue) {
    switch (inputId) {
      case 'checkout-email':
        return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      case 'checkout-phone':
        // Dutch phone numbers are 8 digits
        return !/^\+?\d{8}$/.test(sanitizedValue);
      case 'checkout-postcode':
        // Dutch postcodes are 4 digits
        return !/^\d{4}$/.test(sanitizedValue);
      default:
        return value === '';
    }
  }

  validateInputBelgium(inputId, value, sanitizedValue) {
    switch (inputId) {
      case 'checkout-email':
        return !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
      case 'checkout-phone':
        // Belgian phone: +32 + 8 or 9 digits, or domestic 0 + 8 or 9 digits
        return !/^(?:\+32|0)\d{8,9}$/.test(sanitizedValue);
      case 'checkout-postcode':
        // Belgian postcodes are 4 digits, range 1000–9999
        return !/^[1-9]\d{3}$/.test(sanitizedValue);
      default:
        return value === '';
    }
  }
}

export default InputValidation;
